var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"callout--button"},[_c('a',{staticClass:"button--primary m-full",attrs:{"href":_vm.link}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('i',{staticClass:"fa fa-caret-right"})])])}
var staticRenderFns = []

export { render, staticRenderFns }